import LegalShell from "./LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy" lastUpdated="February 2026">
      <p>
        Fitest, a trading name of <strong>Leadsopedia Limited</strong> (Company No. 13145058), with registered office at
        5 Brayford Square, London, E1 0SG ("we", "us", "our"), is committed to protecting and respecting your privacy in
        line with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We may collect, store and use the following information about you:</p>
      <ul>
        <li>Identity & Contact Data: name, company, email address, telephone number.</li>
        <li>Audit Response Data: your answers to the Fitest wellness audit, your derived score (0–100) and tier (Critical, Exposed, Performing, Elite).</li>
        <li>Marketing Preferences: whether you have opted in to be contacted by the issuing licence holder.</li>
        <li>Technical Data: IP address, browser type, device and access logs.</li>
      </ul>

      <h2>2. Lawful Basis for Processing</h2>
      <p>We process your personal data on the following lawful bases under Article 6 of the UK GDPR:</p>
      <ul>
        <li><strong>Consent</strong> — when you submit an audit and explicitly opt in to be contacted by your gym or employer.</li>
        <li><strong>Legitimate interests</strong> — to deliver the audit service, prevent abuse, and improve our platform.</li>
        <li><strong>Contractual necessity</strong> — when you hold a Fitest licence (gym or business).</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To generate, score and deliver your wellness audit and PDF report.</li>
        <li>To allow the issuing licence holder to view your aggregated, anonymised or opt-in-revealed data.</li>
        <li>To respond to enquiries submitted via our contact and demo forms.</li>
        <li>To meet legal, accounting or regulatory obligations.</li>
      </ul>

      <h2>4. Sharing of Information</h2>
      <p>We do not sell your personal data. We share data only with:</p>
      <ul>
        <li>The licence holder who issued the audit you completed (only if you opted in).</li>
        <li>Vetted sub-processors who provide hosting, payment (Stripe), and form submission (Formspree) services.</li>
        <li>Authorities where legally required.</li>
      </ul>

      <h2>5. International Transfers</h2>
      <p>
        Some of our sub-processors may be based outside the UK / EEA. Where this is the case, we rely on Standard
        Contractual Clauses or other approved safeguards under the UK GDPR.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain audit submissions and lead records for as long as you remain on our platform, or as required by
        applicable law. You may request deletion at any time by emailing <a href="mailto:hello@fitest.co.uk">hello@fitest.co.uk</a>.
      </p>

      <h2>7. Your Rights</h2>
      <p>Under UK GDPR you have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you.</li>
        <li>Request correction or erasure of your data.</li>
        <li>Object to or restrict our processing.</li>
        <li>Data portability.</li>
        <li>Withdraw consent at any time, where consent is the lawful basis.</li>
        <li>Lodge a complaint with the UK Information Commissioner's Office (ICO).</li>
      </ul>

      <h2>8. Cookies</h2>
      <p>
        We use strictly necessary cookies for authentication and session management, and limited analytics cookies to
        improve our platform. You can control cookies through your browser settings.
      </p>

      <h2>9. Contact</h2>
      <p>
        If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at{" "}
        <a href="mailto:hello@fitest.co.uk">hello@fitest.co.uk</a> or write to us at 5 Brayford Square, London, E1 0SG.
      </p>
    </LegalShell>
  );
}
